var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChevronLeft = function SvgChevronLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8659 17.0041C13.7312 17.0036 13.5979 16.9759 13.4742 16.9226C13.3505 16.8693 13.2388 16.7916 13.1459 16.6941L9.28586 12.6941C9.10263 12.5072 9 12.2558 9 11.9941C9 11.7323 9.10263 11.481 9.28586 11.2941L13.2859 7.29409C13.3791 7.20085 13.4898 7.12689 13.6116 7.07643C13.7334 7.02597 13.864 7 13.9959 7C14.1277 7 14.2583 7.02597 14.3801 7.07643C14.5019 7.12689 14.6126 7.20085 14.7059 7.29409C14.7991 7.38733 14.8731 7.49802 14.9235 7.61984C14.974 7.74166 14.9999 7.87223 14.9999 8.00409C14.9999 8.13595 14.974 8.26652 14.9235 8.38834C14.8731 8.51016 14.7991 8.62085 14.7059 8.71409L11.4059 12.0041L14.5859 15.3041C14.7721 15.4915 14.8766 15.7449 14.8766 16.0091C14.8766 16.2733 14.7721 16.5267 14.5859 16.7141C14.4912 16.808 14.3788 16.882 14.2551 16.9318C14.1315 16.9816 13.9991 17.0062 13.8659 17.0041Z",
    fill: "#edf3f6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron_left.d2d87c4b.svg";
export { ForwardRef as ReactComponent };